import React, { Component } from "react";
import classes from "./Auth.module.css";
import Input from "../../../components/Input/Input";
import is from "is_js";
import { connect } from "react-redux";
import { autoLogin, auth } from "../../../store/actions/actions";

class Auth extends Component {
  state = {
    email: "",
    password: "",
    isMailValid: true,
    isPasswordValid: false,
  };

  async componentDidMount() {
    this.props.autoLogin();
  }

  //отменяем действие формы
  submitHandler = (e) => {
    e.preventDefault();
  };

  //обработчик почты
  emailChangeHandler = (e) => {
    e.preventDefault();

    const check = e.target.value;
    let isMailValid = is.email(check);

    this.setState({
      email: e.target.value,
      isMailValid,
    });
  };

  //обработчик пароля
  passwordChangeHandler = (e) => {
    e.preventDefault();

    const check = e.target.value;
    let isPasswordValid = false;

    if (check.length >= 6) {
      isPasswordValid = true;
    }

    this.setState({
      password: e.target.value,
      isPasswordValid,
    });
  };

  //обработчик входа
  loginHandler = async () => {
    this.props.auth(this.state.email, this.state.password);
  };

  render() {
    return (
      <div className={classes.Auth}>
        <form
          className={classes.Auth_form}
          onSubmit={(e) => this.submitHandler(e)}
        >
          <Input
            label="Auth-email"
            labelTxt="Email:"
            type="email"
            id="Auth-email"
            required={true}
            placeholder="email"
            onChange={(e) => this.emailChangeHandler(e)}
            value={this.state.email}
          />
          <Input
            label="Auth-pass"
            labelTxt="Password:"
            type="password"
            required={true}
            placeholder="password"
            onChange={(e) => this.passwordChangeHandler(e)}
            value={this.state.password}
          />
          <div>
            <button
              disabled={!this.state.isMailValid || !this.state.isPasswordValid}
              onClick={this.loginHandler}
            >
              Login
            </button>
          </div>
        </form>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    auth: (email, password) => dispatch(auth(email, password)),
    autoLogin: () => dispatch(autoLogin()),
  };
}

export default connect(null, mapDispatchToProps)(Auth);
